import { useHealth } from '@/features/health/use-health'

/**
 * `compact` is the folded rail: the dot alone, with the wording moved into its
 * accessible name and tooltip. The colour is the message at that size — but a
 * colour with no name behind it says nothing to a screen reader.
 */
export function ApiStatusBadge({ compact = false }: { compact?: boolean }) {
  const { data, isPending, isError } = useHealth()

  const { dot, label } = isPending
    ? { dot: 'bg-muted', label: 'API …' }
    : isError
      ? { dot: 'bg-danger', label: 'API offline' }
      : data?.status === 'ok'
        ? { dot: 'bg-positive', label: `API v${data.version}` }
        : { dot: 'bg-warning', label: 'API eingeschränkt' }

  if (compact) {
    return (
      <span role="img" aria-label={label} title={label} className="inline-flex p-1">
        <span className={`size-2 rounded-full ${dot}`} />
      </span>
    )
  }

  return (
    <span className="text-muted inline-flex items-center gap-2 text-xs">
      <span className={`size-2 rounded-full ${dot}`} aria-hidden />
      {label}
    </span>
  )
}
